export const STAFF_TYPE_OPTIONS = [
  { value: 'tutti', label: 'Tutti' },
  { value: 'interno', label: 'Interno' },
  { value: 'esterno', label: 'Esterno' },
];

export function getInitialStaffForm() {
  return {
    name: '',
    firstName: '',
    lastName: '',
    role: '',
    email: '',
    phone: '',
    skills: '',
    tipoPersonale: 'esterno',
    accessType: 'external',
    linkedWorkspaceUserId: '',
    customFields: {},
  };
}
